export const ARTICLE_FEATURE = {
  PUBLIC: 'Public',
  SESSION_WRAP: 'SessionWrap',
  SPONSORED: 'Sponsored',
  TRADE_COMPASS: 'TradeCompass'
}

export const RERENDER_NON_HYDRATED_ARTICLE_COMPONENTS_BUS_NAME =
  'RERENDER_NON_HYDRATED_ARTICLE_COMPONENTS_BUS_NAME'
